import arg from '../images/banderas/ARGENTINA_FLAG_.png';
import bol from '../images/banderas/BOLIVIA_FLAG_.png';
import chi from '../images/banderas/CHILE_FLAG_.png';
import col from '../images/banderas/COLOMBIA_FLAG_.png';
import cos from '../images/banderas/COSTA RICA_FLAG_.png';
import cub from '../images/banderas/CUBA_FLAG_.png';
import ecu from '../images/banderas/ECUADOR_FLAG_.png';
import sal from '../images/banderas/EL SALVADOR_FLAG_.png';
import esp from '../images/banderas/ESPAÑA_FLAG_.png';
import usa from '../images/banderas/ESTADOS UNIDOS_FLAG_.png';
import gua from '../images/banderas/GUATEMALA_FLAG_.png';
import hon from '../images/banderas/HONDURAS_FLAG_.png';
import mex from '../images/banderas/MEXICO_FLAG_.png';
import nic from '../images/banderas/NICARAGUA_FLAG_.png';
import pan from '../images/banderas/PANAMÁ_FLAG_.png';
import par from '../images/banderas/PARAGUAY_FLAG_.png';
import per from '../images/banderas/PERÚ_FLAG_.png';
import pue from '../images/banderas/PUERTO RICO_FLAG_.png';
import rep from '../images/banderas/REPÚBLICA DOMINICANA _FLAG_.png';
import uru from '../images/banderas/URUGUAY_FLAG_.png';
import ven from '../images/banderas/VENEZUELA_FLAG_.png';

const paises = [
	{
		nombre: 'Argentina',
		ind: '+54 ',
		img: arg,
	},
	{
		nombre: 'Bolivia',
		ind: '+591 ',
		img: bol,
	},
	{
		nombre: 'Chile',
		ind: '+56 ',
		img: chi,
	},
	{
		nombre: 'Colombia',
		ind: '+57 ',
		img: col,
	},
	{
		nombre: 'Costa Rica',
		ind: '+506 ',
		img: cos,
	},
	{
		nombre: 'Cuba',
		ind: '+53 ',
		img: cub,
	},
	{
		nombre: 'Ecuador',
		ind: '+593 ',
		img: ecu,
	},
	{
		nombre: 'El Salvador',
		ind: '+503 ',
		img: sal,
	},
	{
		nombre: 'España',
		ind: '+34 ',
		img: esp,
	},
	{
		nombre: 'Estados Unidos',
		ind: '+1 ',
		img: usa,
	},
	{
		nombre: 'Guatemala',
		ind: '+502 ',
		img: gua,
	},
	{
		nombre: 'Honduras',
		ind: '+504 ',
		img: hon,
	},
	{
		nombre: 'México',
		ind: '+52 ',
		img: mex,
	},
	{
		nombre: 'Nicaragua',
		ind: '+505 ',
		img: nic,
	},
	{
		nombre: 'Panamá',
		ind: '+507 ',
		img: pan,
	},
	{
		nombre: 'Paraguay',
		ind: '+595 ',
		img: par,
	},
	{
		nombre: 'Perú',
		ind: '+51 ',
		img: per,
	},
	{
		nombre: 'Puerto Rico',
		ind: '+1787 ',
		img: pue,
	},
	{
		nombre: 'República Dominicana',
		ind: '+1809 ',
		img: rep,
	},
	{
		nombre: 'Uruguay',
		ind: '+598 ',
		img: uru,
	},
	{
		nombre: 'Venezuela',
		ind: '+58 ',
		img: ven,
	},
];

export const paises2 = [
	{ label: 'Argentina', value: 'ARG', ind: '+54 ', img: arg },
	{ label: 'Bolivia', value: 'BOL', ind: '+591 ', img: bol },
	{ label: 'Chile', value: 'CHL', ind: '+56 ', img: chi },
	{ label: 'Colombia', value: 'COL', ind: '+57 ', img: col },
	{ label: 'Costa Rica', value: 'CRI', ind: '+506 ', img: cos },
	{ label: 'Cuba', value: 'CUB', ind: '+53 ', img: cub },
	{ label: 'Ecuador', value: 'ECU', ind: '+593 ', img: ecu },
	{ label: 'El Salvador', value: 'SLV', ind: '+503 ', img: sal },
	{ label: 'España', value: 'ESP', ind: '+34 ', img: esp },
	{ label: 'Estados Unidos', value: 'USA', ind: '+1 ', img: usa },
	{ label: 'Guatemala', value: 'GTM', ind: '+502 ', img: gua },
	{ label: 'Honduras', value: 'HND', ind: '+504 ', img: hon },
	{ label: 'México', value: 'MEX', ind: '+52 ', img: mex },
	{ label: 'Nicaragua', value: 'NIC', ind: '+505 ', img: nic },
	{ label: 'Panamá', value: 'PAN', ind: '+507 ', img: pan },
	{ label: 'Paraguay', value: 'PRY', ind: '+595 ', img: par },
	{ label: 'Perú', value: 'PER', ind: '+51 ', img: per },
	{ label: 'Puerto Rico', value: 'PRI', ind: '+1787 ', img: pue },
	{ label: 'República Dominicana', value: 'DOM', ind: '+1809 ', img: rep },
	{ label: 'Uruguay', value: 'URY', ind: '+598 ', img: uru },
	{ label: 'Venezuela', value: 'VEN', ind: '+58 ', img: ven },
];

export const cursos = [
	{
		nombre: 'Aprender 3D desde cero',
	},
	{
		nombre: 'Modelos para impresión 3D',
	},
	{
		nombre: 'Personajes para videojuegos',
	},
	{
		nombre: 'Personajes para animación',
	},
	{
		nombre: 'Escultura Realista',
	},
	{
		nombre: 'Rigging',
	},
	{
		nombre: 'Animación',
	},
	{
		nombre: 'Otros...',
	},
];

export default paises;
